<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        <span style="color:#0cabc2">Customer Basket Owe Record</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search by customer" single-line hide-detail></v-text-field>
    </v-toolbar>

    <p v-if="errors.length">
      <v-alert :value="true" color="primary" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table
      :headers="headers"
      :items="basket_record"
      :search="search"
      active-class="highlighted"
      :disable-initial-sort="true"
      class="elevation-1"
    >
      <v-progress-linear v-show="isLoading"></v-progress-linear>

      <template slot="items" slot-scope="props">
        <!-- <tr 
        @click="selected_customer_record(props.item.id)"
        > -->
        <tr>
          <td class="text-xs">
            <b>{{ props.item.customer_name }}</b>
          </td>
          <td
            class="text-xs"
            :style="{color:(props.item.status == 'we owe customer' ? '#ff0000':'green')}"
          ><b>{{ props.item.status }}</b></td>
          <td class="text-xs">{{ props.item.quantity }}</td>
        </tr>
      </template>

      <v-alert
        slot="no-results"
        :value="true"
        color="primary"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    <!-- <v-flex offset-xs10>
      <v-btn color="primary" @click.native="generatePDF()" class="square">Report</v-btn>
    </v-flex> -->
    <!-- <v-dialog v-model="selected_dialog">
      <v-card>
        <v-card-title>
          <span class="headline">Transaction</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 lg12 sm12 md12>
                <customerDataTableSelectedCustomer ref="selected"></customerDataTableSelectedCustomer>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="selected_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-snackbar v-model="snackbar" :top="true">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
//import customerDataTableSelectedCustomer from "@/components/basket/customerDataTableSelectedCustomer";
//import * as jsPDF from "jspdf";
//import "jspdf-autotable";
import moment from "moment";
export default {
  components: {
    // customerDataTableSelectedCustomer
  },
  data: () => ({
    search: "",
    isLoading: true,
    snackbar: false,
    dialog: false,
    errors: "",
    baseUrl: baseUrl,
    selected_dialog: false,
    VegeLogo: "",
    date_now: moment().format("DD-MM-YYYY"),

    headers: [
      { text: "Customer Name", align: "", value: "customer_name" },
      { text: "Status", align: "", value: "status" },
      { text: "Quantity", align: "", value: "quantity" }
    ],
    basket_record: []
  }),

  computed: {},

  watch: {},

  created() {
    this.record();
    this.getImageLogo();
  },

  methods: {
    record() {
      const params = new URLSearchParams();
      params.append("getCustomerBasketRecord", "getCustomerBasketRecord");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.basket_record = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.basket_record = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    selected_customer_record(customer_id) {
      console.log(customer_id);
      this.$refs.selected.record(customer_id);
      this.selected_dialog = true;
    },
    // getImageLogo(){    
    //    const toDataURL = url =>
    //     fetch(url)
    //       .then(response => response.blob())
    //       .then(
    //         blob =>
    //           new Promise((resolve, reject) => {
    //             const reader = new FileReader();
    //             reader.onloadend = () => resolve(reader.result);
    //             reader.onerror = reject;
    //             reader.readAsDataURL(blob);
    //           })
    //       );
   

    //   toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
    //     this.VegeLogo = dataUrl;
    //   });


    //   },
    // generatePDF: function() {
    //   // var PdfMainArray = this.$refs.table_fetched_ref.fetched_vege;

      
    //   var doc = new jsPDF();

      
    //   doc.addImage(this.VegeLogo, 15, 10, 20, 23);

    //   doc.setFontSize(13);
    //   doc.setFontStyle("bold");
    //   doc.text(37, 15, "JT VEGE Trading Sdn Bhd");

    //   doc.setFontSize(10);
    //   doc.setFontStyle("normal");
    //   doc.text(37, 20, "15,Jalan Cenderai 10 81750 Masai Johor");
    //   doc.text(38, 25, "Phone: 07-3875540");
    //   doc.text(38, 30, "Fax: 07-3875541");

    //   doc.setFontSize(11);
    //   doc.setFontStyle("bold");
    //   doc.text(168, 15, "Date: ");
 

    //   doc.setFontSize(10);
    //   doc.setFontStyle("normal");
    //   doc.text(178, 15, this.date_now);


    //   doc.setFontSize(11);
    //   doc.setFontStyle("normal");
    //   doc.text(15, 45, "Customer Basket Record");

    //   doc.setFontSize(11);
    //   doc.setFontStyle("bold");
    //   doc.text(45, 45, " ");

    //   doc.setLineWidth(0.3);
    //   doc.line(15, 47, 192, 47);
    //   //// array add check box
  
    //   //////auto table
    //   doc.autoTable({
    //     pageBreak: "auto",
    //     startY: 50,
    //     theme: "grid",

    //     columnStyles: {
    //       customer_name: { halign: "", fillColor: "#f7f9f9" },
    //       status: { halign: "", fillColor: "#f7f9f9" },
    //       quantity: { halign: "", fillColor: "#f7f9f9" }
    //     },
    //     columns: [
    //       { header: "Customer Name", dataKey: "customer_name" },
    //       { header: "Type", dataKey: "status" },
    //       { header: "Quantity", dataKey: "quantity" },
      
    //     ],
    //     body: this.basket_record
    //   });
    //   //////after auto table
    //   doc.setDrawColor(0, 0, 0);
    //   doc.setLineWidth(0.3);
    //   doc.line(
    //     15,
    //     doc.autoTable.previous.finalY + 5,
    //     192,
    //     doc.autoTable.previous.finalY + 5
    //   );


    //   // var img = "@/assets/image/broccoli.jpeg";

    //   doc.save("Customer Basket Record.pdf");
    // }
  }
};
</script>

